import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a8f22cd755b8c0014e4e5f0_1787796737410_10c16be2/qipalette/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a8f22cd755b8c0014e4e5f0_1787796737410_10c16be2/qipalette/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a8f22cd755b8c0014e4e5f0_1787796737410_10c16be2/qipalette/src/components/ui/AppLogo.tsx");
